import { Pipe, PipeTransform } from '@angular/core';
import firebase from "firebase"
import { POINT_FLUCT_KIND_LIST, ORDER_STATUS_LIST } from 'src/lib/constants'
import { OrderStatus } from './entity/order';
import { DecimalPipe } from '@angular/common'

@Pipe({
  name: 'convertPointFluckKindToText',
})
export class ConvertPointFluckKindToTextPipe implements PipeTransform {
  transform(kindId: number): string {
    return POINT_FLUCT_KIND_LIST.find(el => el.id === kindId)?.default_text as string
  }
}

@Pipe({
  name: 'convertOrderStatusToText',
})
export class ConvertOrderStatusToTextPipe implements PipeTransform {
  transform(orderStatus: OrderStatus): string {
    return ORDER_STATUS_LIST.find(el => el.name === orderStatus)?.default_text as string
  }
}

@Pipe({
  name: 'convertThousandNum',
})
export class ConvertThousandNumPipe implements PipeTransform {
  transform(value: number): string | number {
    if (value >= 1000) {
      const dPipe = new DecimalPipe('en-US')
      const number = dPipe.transform(Math.floor(value / 100) / 10, '1.1-1')
      return number + 'k'
    } else {
      return value
    }
  }
}
@Pipe({
  name: 'convertFileSizeToString',
})
export class ConvertFileSizeToString implements PipeTransform {
  transform(size: number): string {
      // 1 KB = 1024 Byte
      const kb = 1024
      const mb = Math.pow(kb, 2)
      const gb = Math.pow(kb, 3)
      const tb = Math.pow(kb, 4)
      const pb = Math.pow(kb, 5)
      const round = (size, unit) => {
          return Math.round(size / unit * 100.0) / 100.0
      }
  
      if (size >= pb) {
          return round(size, pb) + 'PB';
      } else if (size >= tb) {
          return round(size, tb) + 'TB';
      } else if (size >= gb) {
          return round(size, gb) + 'GB';
      } else if (size >= mb) {
          return round(size, mb) + 'MB';
      } else if (size >= kb) {
          return round(size, kb) + 'KB';
      }
      return size + 'バイト';
  }
}

@Pipe({
  name: 'convertFirestoreTimestampToString',
})
export class ConvertFirestoreTimestampToString implements PipeTransform {
  transform(timestamp: firebase.firestore.Timestamp): string {
    const option: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit", 
    } 
    return new Date(timestamp.seconds * 1000).toLocaleString("ja-JP", option)
  }
}
